@if (inseason) {
  <div class="currentClass">
    <div class="row orders_rowsection">
      <div class="col-xs-12 orders_graphtitle">
        {{"ordersummary.currSeasonstatus" | cxTranslate}}<span class="orders_graphsubtitle">{{inseason}}</span>
      </div>
      <div id="ordergraphcontainer" [chart]="columnChart"></div>
    </div>
  </div>
}
<app-new-orders [orderSummary]="orderSummary"></app-new-orders>